export const normalizeAzimuth = (a) => {
    if (a < -Math.PI) {
        a += 2 * Math.PI;
    }
    if (a > Math.PI) {
        a -= 2 * Math.PI;
    }
    return a;
};
